import { render, staticRenderFns } from "./postalcode.vue?vue&type=template&id=2fe28907"
import script from "./postalcode.vue?vue&type=script&lang=js"
export * from "./postalcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports